/**
 * Whether the in-app notification SSE should hold an HTTP connection.
 *
 * Each browser tab is a separate JS context, so each tab used to keep its own
 * long-lived SSE open. Under HTTP/1.1 Chrome caps ~6 connections per host —
 * opening several lender overviews via "Open in new tab" then starved the rest
 * (pending heartbeat / unread_count, blank pages). Background tabs pause the
 * stream; the focused tab keeps (or resumes) it.
 */
export function shouldHoldInappSseConnection(
  streamStarted: boolean,
  documentHidden: boolean
): boolean {
  return streamStarted && !documentHidden;
}
